export type StepStatus = 'default' | 'active' | 'completed';
export type InitOnboardingAction = 'start' | 'close';
export type InitOnboardingDialog = 'start' | 'finish';
export type ExitOnboardingAction = 'exit' | 'cancel';

export enum OnboardingStepNumber {
  Step1 = 1,
  Step2 = 2,
  Step3 = 3,
  Step4 = 4,
}

export enum StepGuideId {
  // Alt actions for when there are no applicable items for that guide or needs special handling
  // (e.g. no entries to add email to, no contacts to add, etc.)
  AddContact1 = 'addContact1',
  AddContact1Alt = 'addContact1Alt',
  AddContact2 = 'addContact2',
  SaveEmail1 = 'saveEmail1',
  SaveEmail1Alt = 'saveEmail1Alt',
  SaveEmail2 = 'saveEmail2',
  EntryActions1 = 'entryActions1',
  EntryActions1Alt = 'entryActions1Alt',
  EntryActions2 = 'entryActions2',
  EntryActions3 = 'entryActions3',
  EntryActions3Alt = 'entryActions3Alt',
}

export interface Onboarding {
  step: OnboardingStep;
  guides: StepGuide[];
}

export interface OnboardingStep {
  step: OnboardingStepNumber;
  name: string;
  status: StepStatus;
  icon: Icon;
}

export interface Icon {
  name: string;
  type: string;
}

export interface StepGuide {
  stepId: StepGuideId;
  guide: {
    step: number;
    total: number;
  };
  title: string;
  content: string;
  button?: string;
  hideStepCount?: boolean;
}
